// third-party
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// project imports
import snackbarReducer from './slices/snackbar';
import customerReducer from './slices/customer';
import contactReducer from './slices/contact';
import productReducer from './slices/product';
import chatReducer from './slices/chat';
import calendarReducer from './slices/calendar';
// import mailReducer from './slices/mail';
import userReducer from './slices/user';
import cartReducer from './slices/cart';
import kanbanReducer from './slices/kanban';
import menuReducer from './slices/menu';
import submissionReducer from './slices/submission';
import tenantReducer from './slices/tenant';
import orderReducer from './slices/order';
import sectionReducer from './slices/section';
import dashboardReducer from './slices/dashboard';
import discoverSendMessageDialogReducer from './slices/discover-send-message-dialog';
import modalReducer from './slices/modal';
import dataFocusViewReducer from './slices/dataFocusView';
import notificationReducer from './slices/notification';

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
    section: sectionReducer,
    snackbar: snackbarReducer,
    discoverSendMessageDialog: discoverSendMessageDialogReducer,
    cart: persistReducer(
        {
            key: 'cart',
            storage,
            keyPrefix: 'berry-'
        },
        cartReducer
    ),
    kanban: kanbanReducer,
    customer: customerReducer,
    contact: contactReducer,
    product: productReducer,
    chat: chatReducer,
    calendar: calendarReducer,
    // mail: mailReducer,
    user: userReducer,
    menu: menuReducer,
    submission: submissionReducer,
    userTenant: tenantReducer,
    createOrder: orderReducer,
    dashboard: dashboardReducer,
    modal: modalReducer,
    dataFocusView: dataFocusViewReducer,
    notification: notificationReducer
});

export default reducer;
